/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { ArrayExtensions, ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IProductSpecificationViewProps } from '@msdyn365-commerce-modules/product-specification/src/modules/product-specification/./product-specification';

const ProductSpecificationView: React.FC<IProductSpecificationViewProps> = props => {
    const { ProductSpecification, ProductSpecificationTableProps, ProductSpecificationTableBodyProps, productSpecificationResult } = props;
    const rowdata = productSpecificationResult &&
                    ArrayExtensions.hasElements(productSpecificationResult) &&
                    productSpecificationResult.filter((row) => !ObjectExtensions.isNullOrUndefined(row));

                    React.useEffect(() => {
                
                        const url = window.location.href;
                        const script = document.createElement('script');
                        url.indexOf("dynamics.com/uk") > -1 ? script.src = "https://apps.bazaarvoice.com/deployments/peruvianconnectionuk/main_site/staging/en_GB/bv.js"
                        : url.indexOf("dynamics.com/de") > -1 ? script.src = "https://apps.bazaarvoice.com/deployments/peruvianconnectionde/main_site/staging/de_DE/bv.js"
                        : url.indexOf("peruvianconnection.com") > -1 ? script.src = "https://apps.bazaarvoice.com/deployments/peruvianconnection/main_site/production/en_US/bv.js"
                        : url.indexOf("peruvianconnection.co.uk") > -1 ? script.src = "https://apps.bazaarvoice.com/deployments/peruvianconnectionuk/main_site/production/en_GB/bv.js"
                        : url.indexOf("peruvianconnection.de") > -1 ? script.src = "https://apps.bazaarvoice.com/deployments/peruvianconnectionde/main_site/production/de_DE/bv.js"
                        : script.src = "https://apps.bazaarvoice.com/deployments/peruvianconnection/main_site/staging/en_US/bv.js"
                        script.async = true;
                        document.getElementsByClassName("ms-product-specification")[0].appendChild(script);
                        return () => {
                            document.getElementsByClassName("ms-product-specification")[0].removeChild(script);
                        }
                
                    }, [])

    return (
        rowdata && ArrayExtensions.hasElements(rowdata) ? (
            <Module {...ProductSpecification}>
                {props.title}
                <Node {...ProductSpecificationTableProps}>
                    <Node {...ProductSpecificationTableBodyProps}>
                        { rowdata }
                    </Node>
                </Node>
                <div className="bv-reviews" data-bv-product-id={rowdata.at(0)?.props.cellData.props.dangerouslySetInnerHTML.__html.substring(0,6)} data-bv-show="reviews"></div>
            </Module>) : null
    );
};

export default ProductSpecificationView;
